import { render, staticRenderFns } from "./GiftCards.vue?vue&type=template&id=1583bbd6"
import script from "./GiftCards.vue?vue&type=script&lang=js"
export * from "./GiftCards.vue?vue&type=script&lang=js"
import style0 from "./GiftCards.vue?vue&type=style&index=0&id=1583bbd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports